import { Link } from "react-router-dom";

export default function ContactCta() {
  return (
    <section className="mx-auto max-w-7xl px-4 md:px-6 py-14 md:py-20">
      <div className="relative overflow-hidden rounded-3xl bg-foreground-950 px-6 py-12 md:px-12 md:py-16">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=Dreamy%20dark%20fairy%20night%20scene%20with%20soft%20glowing%20spirit%20lights%20and%20floating%20petals%2C%20warm%20amber%20and%20rose%20glow%20against%20deep%20warm%20brown%2C%20ethereal%20romantic%20fantasy%20illustration%2C%20atmospheric%2C%20wide%20composition%2C%20high%20quality&width=1600&height=700&seq=cta-bg&orientation=landscape"
            alt="萌妖图鉴投稿邀请背景"
            title="投稿韩国妖精漫画角色资料"
            className="h-full w-full object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/80 to-foreground-950/40"></div>
        </div>

        <div className="relative z-10 max-w-2xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-background-50/10 px-3 py-1 text-xs font-medium text-background-200 backdrop-blur">
            <i className="ri-megaphone-line" aria-hidden="true"></i>
            共建图鉴
          </span>
          <h2 className="mt-4 font-heading text-2xl font-bold leading-tight text-background-50 md:text-3xl">
            有想补充的妖精漫画女主资料？
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-background-200 md:text-base">
            无论是冷门萌娘人设、独家CP整理，还是想纠错补充，都可以通过我们的投稿表单告诉我们。经审核后，你的内容会收录进图鉴并标注来源。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about#contact"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-send-plane-line" aria-hidden="true"></i>
              去投稿
            </Link>
            <Link
              to="/encyclopedia"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-background-50/10 px-6 py-2.5 text-sm font-medium text-background-100 transition-colors hover:bg-background-50/20"
            >
              逛图鉴
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}